/**
 * Параметры развертывания агента ShbDeployer на управляемых узлах.
 *
 * Значения являются заготовками: перед промышленной эксплуатацией укажите адрес
 * корпоративного реестра образов и хранилища манифестов, доступные вашей инфраструктуре.
 * Все команды установки агента в интерфейсе формируются только из этих констант —
 * адреса не дублируются в шаблонах и контроллерах.
 */

/**
 * Значение, заданное на этапе сборки (product.config.js → webpack DefinePlugin),
 * либо запасное значение — вне сборки webpack (модульные тесты, storybook).
 */
function buildTimeValue(defined, fallback) {
  return typeof defined === 'undefined' ? fallback : defined;
}

/** Образ агента. Задаётся переменной сборки SHB_AGENT_IMAGE. */
export const AGENT_IMAGE = buildTimeValue(typeof __SHB_AGENT_IMAGE__ === 'undefined' ? undefined : __SHB_AGENT_IMAGE__, 'registry.example.org/shbdeployer/agent');

/** Имя стека и сервиса агента в Docker Swarm. */
export const AGENT_STACK_NAME = 'shbdeployer-agent';

/** Имя тома с данными агента. */
export const AGENT_DATA_VOLUME = 'shbdeployer_agent_data';

/** Имя контейнера или сервиса Edge-агента на управляемом узле. */
export const EDGE_AGENT_NAME = 'shbdeployer_edge_agent';

/** Имя оверлейной сети агента в Docker Swarm. */
export const AGENT_NETWORK_NAME = 'shbdeployer_agent_network';

/** Имя оверлейной сети Edge-агента в Docker Swarm (Windows). */
export const EDGE_AGENT_NETWORK_NAME = 'shbdeployer_edge_agent_network';

/** Базовый адрес каталога манифестов и сценариев установки агента. Задаётся переменной сборки SHB_AGENT_ASSETS_URL. */
export const AGENT_ASSETS_BASE_URL = buildTimeValue(
  typeof __SHB_AGENT_ASSETS_BASE_URL__ === 'undefined' ? undefined : __SHB_AGENT_ASSETS_BASE_URL__,
  'https://assets.example.org/shbdeployer/agent'
);

/** Манифест агента для Docker Swarm (Linux). */
export function agentStackFileURL(platform = 'linux') {
  return platform === 'windows' ? `${AGENT_ASSETS_BASE_URL}/agent-stack-windows.yml` : `${AGENT_ASSETS_BASE_URL}/agent-stack.yml`;
}

/** Манифест агента для Kubernetes: тип публикации — loadbalancer или nodeport. */
export function agentKubernetesManifestURL(publishMode = 'nodeport') {
  return `${AGENT_ASSETS_BASE_URL}/agent-k8s-${publishMode}.yaml`;
}

/** Сценарий установки Edge-агента. */
export function edgeAgentSetupScriptURL() {
  return `${AGENT_ASSETS_BASE_URL}/edge-agent-setup.sh`;
}

/** Полное имя образа агента с учетом версии платформы. */
export function agentImage(version) {
  return version ? `${AGENT_IMAGE}:${version}` : `${AGENT_IMAGE}:latest`;
}
